import { WINDOW_DIMENSION } from '../action/types';

const { innerWidth, innerHeight } = window;

const initialState = {
  innerWidth,
  innerHeight
};

export default (state = initialState, action) => {
  switch (action.type) {
    case WINDOW_DIMENSION:
      return { ...action.dimension };
    default:
      return state;
  }
};
